<template>
  <vxe-table border resizable show-overflow :data="tableData">
    <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
    <vxe-table-column
      v-for="(item, index) of tableColumn"
      :key="index"
      :field="item.field"
      :title="item.title"
      :edit-render="item.itemRender"
      :width="item.width"
    >
    </vxe-table-column>
  </vxe-table>
</template>

<script>
  export default {
    name: 'ExpandTable',
    props: {
      fetchTableData: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableData: [],
        tableColumn: [
          {
            title: '付款金额',
            field: 'paymemtedAmount',
          },
          {
            title: '付款单号',
            field: 'settlementNo',
          },
          {
            title: '付款日期',
            field: 'paymentDate',
          },
          {
            title: '费用期间',
            field: 'expensePeriod',
          },
        ],
      };
    },
    watch: {
      fetchTableData: {
        handler(val) {
          if (val && val.length) {
            this.tableData = val;
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style></style>
